import React from 'react';
import { Gift, Zap } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';

const SOCIABUZZ_LINK = "https://sociabuzz.com/helloasyrol/tribe";

function SociaBuzzSection() {
  return (
    <section
      id="sociabuzz"
      className="relative z-10 flex items-center justify-center px-3 md:px-10 py-16 md:py-24 overflow-hidden"
      data-testid="sociabuzz-section"
    >
      <div className="max-w-3xl mx-auto w-full">
        {/* Split neon card — Tribe Boost */}
        <div
          id="sociabuzz-card"
          className="relative rounded-3xl overflow-hidden border border-[#00FF88]/25 will-change-transform group"
          style={{
            background: "linear-gradient(135deg, rgba(10,10,10,0.92) 0%, rgba(15,20,20,0.88) 100%)",
            backdropFilter: "blur(20px)",
            boxShadow: "0 0 40px rgba(0,255,136,0.15), 0 20px 60px rgba(0,0,0,0.5)"
          }}
        >
          {/* TikTok-inspired glitch accents (pink/cyan) */}
          <div
            className="absolute -top-24 -right-24 w-64 h-64 rounded-full pointer-events-none opacity-30"
            style={{
              background: "radial-gradient(circle, rgba(255,0,110,0.35) 0%, transparent 70%)",
              filter: "blur(30px)"
            }}
          />
          <div
            className="absolute -bottom-24 -left-24 w-64 h-64 rounded-full pointer-events-none opacity-30"
            style={{
              background: "radial-gradient(circle, rgba(0,242,255,0.35) 0%, transparent 70%)",
              filter: "blur(30px)"
            }}
          />

          {/* Scanning laser line */}
          <div
            className="absolute inset-0 pointer-events-none opacity-40"
            style={{
              background: "linear-gradient(180deg, transparent 48%, rgba(0,255,136,0.35) 50%, transparent 52%)",
              backgroundSize: "100% 200%",
              animation: "sbScan 6s linear infinite"
            }}
          />

          <div className="relative z-10 p-6 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
            {/* Left icon cluster */}
            <div className="md:col-span-3 flex justify-center">
              <div className="relative">
                {/* Pulsing ring */}
                <div
                  className="absolute inset-0 rounded-2xl"
                  style={{
                    boxShadow: "0 0 30px rgba(0,255,136,0.35)",
                    animation: "sbPulse 2s ease-in-out infinite"
                  }}
                />
                <div
                  className="relative w-24 h-24 md:w-28 md:h-28 rounded-2xl flex items-center justify-center border-2 border-[#00FF88]/50"
                  style={{
                    background: "linear-gradient(135deg, rgba(0,255,136,0.08) 0%, rgba(255,0,110,0.06) 100%)"
                  }}
                >
                  <Gift className="w-12 h-12 md:w-14 md:h-14 text-[#00FF88]" strokeWidth={1.5} />
                </div>
                {/* TikTok badge overlay */}
                <div
                  className="absolute -bottom-2 -right-2 w-9 h-9 rounded-full flex items-center justify-center border border-[#0A0A0A]"
                  style={{
                    background: "linear-gradient(135deg, #ff0050 0%, #00f2ea 100%)",
                    boxShadow: "0 0 10px rgba(255,0,110,0.5)"
                  }}
                >
                  <FaTiktok className="w-4 h-4 text-white" />
                </div>
              </div>
            </div>

            {/* Right content */}
            <div className="md:col-span-9 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                <span className="text-[9px] md:text-[10px] font-inter tracking-[0.3em] uppercase text-[#00FF88] font-semibold" style={{ textShadow: "0 0 8px rgba(0,255,136,0.4)" }}>
                  ● Live on TikTok
                </span>
                <span className="text-[9px] md:text-[10px] font-inter tracking-widest uppercase text-gray-500">
                  / Tribe Support
                </span>
              </div>

              <h3 className="font-teko text-3xl sm:text-4xl md:text-5xl font-bold uppercase leading-[0.95] text-[#F5F5F5] mb-2">
                LIVETRADE{" "}
                <span className="text-[#00FF88]" style={{ textShadow: "0 0 18px rgba(0,255,136,0.5)" }}>
                  PROMOTE
                </span>
              </h3>

              <p className="text-xs md:text-sm text-gray-400 font-inter leading-relaxed mb-5 max-w-lg mx-auto md:mx-0">
                TikTok fam? Hantar tip & notify masa livetrade session.
                Setiap gift akan pop up on livetrade. Grow your brand.
              </p>

              <a
                href={SOCIABUZZ_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-teko text-base md:text-lg tracking-wider uppercase font-bold transition-all duration-300 hover:scale-105 group/btn"
                style={{
                  background: "linear-gradient(135deg, #00FF88 0%, #00f2ea 100%)",
                  color: "#050505",
                  boxShadow: "0 0 25px rgba(0,255,136,0.45), 0 4px 20px rgba(0,242,234,0.2)"
                }}
                data-testid="sociabuzz-cta"
              >
                <Zap className="w-5 h-5" strokeWidth={2.5} />
                <span>Send Tribe Tip</span>
                <span className="text-xs opacity-70 group-hover/btn:translate-x-1 transition-transform">→</span>
              </a>

              <div className="mt-3 text-[10px] text-gray-600 font-inter">
                sociabuzz.com/helloasyrol/tribe
              </div>
            </div>
          </div>

          {/* Bottom neon rail */}
          <div
            className="absolute bottom-0 left-0 right-0 h-[2px]"
            style={{
              background: "linear-gradient(90deg, transparent, #ff0050, #00FF88, #00f2ea, transparent)",
              boxShadow: "0 0 8px rgba(0,255,136,0.5)"
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes sbPulse {
          0%, 100% { transform: scale(1); opacity: 0.7; }
          50% { transform: scale(1.05); opacity: 1; }
        }
        @keyframes sbScan {
          0% { background-position: 0% 100%; }
          100% { background-position: 0% -100%; }
        }
      `}</style>
    </section>
  );
}

export default SociaBuzzSection;
